/**
 * DASHBOARD-MESSAGES-SKELETON.WIDGET
 * Skeleton adapté à dashboard-messages.widget.tsx : le contenu réel est une liste de
 * DashboardQuestionOpenWidget, chacun sa propre Card — le skeleton reprend donc
 * plusieurs petites cards, une par question (caret + titre + badge + libellé d'axe).
 */
import Card from "@/components/card"
import Skeleton, { SkeletonShine } from "@/components/skeleton"

const ROW_COUNT = 5

function SkeletonRow() {
  return (
    <Card isWithoutPadding isFullWidth>
      <div className="rel" style={{ padding: "20px 30px", overflow: "hidden" }}>
        <div className="flex items-center" style={{ gap: 16 }}>
          <Skeleton width={16} height={16} isCircle />
          <Skeleton width={260} height={15} />
          <div style={{ flex: 1 }} />
          <Skeleton width={40} height={14} />
        </div>
        <Skeleton width={160} height={12} style={{ marginTop: 10, marginLeft: 32 }} />
        <SkeletonShine />
      </div>
    </Card>
  )
}

export default function DashboardMessagesSkeletonWidget() {
  return (
    <div>
      {Array.from({ length: ROW_COUNT }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  )
}
